
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue?macro=true";
import { default as index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue?macro=true";
import { default as indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue?macro=true";
import { default as component_45stub8BADXgAiAANNzxjNxtyLzBcrBH8BY9iCmFDmFC82D4g } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_7b50245326c65b2683907a4ace4c8001/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stub8BADXgAiAANNzxjNxtyLzBcrBH8BY9iCmFDmFC82D4gMeta } from "/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_7b50245326c65b2683907a4ace4c8001/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "about-news-slug___en",
    path: "/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___lo",
    path: "/lo/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___ms",
    path: "/ms/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___th",
    path: "/th/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___vi",
    path: "/vi/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___zh-hans",
    path: "/zh-hans/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-news-slug___zh-hant",
    path: "/zh-hant/about/news/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/[...slug].vue")
  },
  {
    name: "about-brand___en",
    path: "/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___lo",
    path: "/lo/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___ms",
    path: "/ms/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___th",
    path: "/th/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___vi",
    path: "/vi/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___zh-hans",
    path: "/zh-hans/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-brand___zh-hant",
    path: "/zh-hant/about/brand",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/brand/index.vue")
  },
  {
    name: "about-contact___en",
    path: "/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___lo",
    path: "/lo/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___ms",
    path: "/ms/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___th",
    path: "/th/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___vi",
    path: "/vi/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___zh-hans",
    path: "/zh-hans/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-contact___zh-hant",
    path: "/zh-hant/about/contact",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/contact/index.vue")
  },
  {
    name: "about-course___en",
    path: "/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___lo",
    path: "/lo/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___ms",
    path: "/ms/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___th",
    path: "/th/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___vi",
    path: "/vi/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___zh-hans",
    path: "/zh-hans/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-course___zh-hant",
    path: "/zh-hant/about/course",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/course/index.vue")
  },
  {
    name: "about-news___en",
    path: "/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___lo",
    path: "/lo/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___ms",
    path: "/ms/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___th",
    path: "/th/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___vi",
    path: "/vi/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___zh-hans",
    path: "/zh-hans/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "about-news___zh-hant",
    path: "/zh-hant/about/news",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/news/index.vue")
  },
  {
    name: "order-create___en",
    path: "/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___lo",
    path: "/lo/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___ms",
    path: "/ms/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___th",
    path: "/th/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___vi",
    path: "/vi/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___zh-hans",
    path: "/zh-hans/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-create___zh-hant",
    path: "/zh-hant/order/create",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/create/index.vue")
  },
  {
    name: "order-quote___en",
    path: "/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___lo",
    path: "/lo/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___ms",
    path: "/ms/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___th",
    path: "/th/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___vi",
    path: "/vi/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___zh-hans",
    path: "/zh-hans/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "order-quote___zh-hant",
    path: "/zh-hant/order/quote",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/quote/index.vue")
  },
  {
    name: "track-order___en",
    path: "/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___lo",
    path: "/lo/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___ms",
    path: "/ms/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___th",
    path: "/th/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___vi",
    path: "/vi/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___zh-hans",
    path: "/zh-hans/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "track-order___zh-hant",
    path: "/zh-hant/track/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/order/index.vue")
  },
  {
    name: "user-profile___en",
    path: "/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___lo",
    path: "/lo/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___ms",
    path: "/ms/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___th",
    path: "/th/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___vi",
    path: "/vi/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___zh-hans",
    path: "/zh-hans/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___zh-hant",
    path: "/zh-hant/user/profile",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/profile/index.vue")
  },
  {
    name: "business-slug___en",
    path: "/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___lo",
    path: "/lo/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___ms",
    path: "/ms/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___th",
    path: "/th/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___vi",
    path: "/vi/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___zh-hans",
    path: "/zh-hans/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "business-slug___zh-hant",
    path: "/zh-hant/business/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/[...slug].vue")
  },
  {
    name: "policy-slug___en",
    path: "/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___lo",
    path: "/lo/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___ms",
    path: "/ms/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___th",
    path: "/th/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___vi",
    path: "/vi/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___zh-hans",
    path: "/zh-hans/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "policy-slug___zh-hant",
    path: "/zh-hant/policy/:slug(.*)*",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/[...slug].vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___lo",
    path: "/lo/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___ms",
    path: "/ms/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___th",
    path: "/th/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___vi",
    path: "/vi/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___zh-hans",
    path: "/zh-hans/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "about___zh-hant",
    path: "/zh-hant/about",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/about/index.vue")
  },
  {
    name: "business___en",
    path: "/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___lo",
    path: "/lo/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___ms",
    path: "/ms/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___th",
    path: "/th/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___vi",
    path: "/vi/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___zh-hans",
    path: "/zh-hans/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "business___zh-hant",
    path: "/zh-hant/business",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/business/index.vue")
  },
  {
    name: "demo___en",
    path: "/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___lo",
    path: "/lo/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___ms",
    path: "/ms/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___th",
    path: "/th/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___vi",
    path: "/vi/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___zh-hans",
    path: "/zh-hans/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "demo___zh-hant",
    path: "/zh-hant/demo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/demo/index.vue")
  },
  {
    name: "forget-password___en",
    path: "/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___lo",
    path: "/lo/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___ms",
    path: "/ms/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___th",
    path: "/th/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___vi",
    path: "/vi/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___zh-hans",
    path: "/zh-hans/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "forget-password___zh-hant",
    path: "/zh-hant/forget-password",
    meta: indexDI20jFvc7xtonOaG1FT5F6EeBHfJ6wMIkdeB1NorHMoMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/forget-password/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___lo",
    path: "/lo/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___ms",
    path: "/ms/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___th",
    path: "/th/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___vi",
    path: "/vi/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___zh-hans",
    path: "/zh-hans/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "login___zh-hant",
    path: "/zh-hant/login",
    meta: index_qGThnOcy_djWkq4DjjHMHbBOBvvInK6J55hGKvhSEAMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/login/index.vue")
  },
  {
    name: "order___en",
    path: "/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___lo",
    path: "/lo/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___ms",
    path: "/ms/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___th",
    path: "/th/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___vi",
    path: "/vi/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___zh-hans",
    path: "/zh-hans/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "order___zh-hant",
    path: "/zh-hant/order",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/order/index.vue")
  },
  {
    name: "policy___en",
    path: "/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___lo",
    path: "/lo/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___ms",
    path: "/ms/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___th",
    path: "/th/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___vi",
    path: "/vi/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___zh-hans",
    path: "/zh-hans/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "policy___zh-hant",
    path: "/zh-hant/policy",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/policy/index.vue")
  },
  {
    name: "register___en",
    path: "/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___lo",
    path: "/lo/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___ms",
    path: "/ms/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___th",
    path: "/th/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___vi",
    path: "/vi/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___zh-hans",
    path: "/zh-hans/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "register___zh-hant",
    path: "/zh-hant/register",
    meta: indexCEboce9iZGbUKtcSFoeqWgWwAICbsmyerkfCAjwFjcsMeta || {},
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/register/index.vue")
  },
  {
    name: "track___en",
    path: "/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___lo",
    path: "/lo/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___ms",
    path: "/ms/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___th",
    path: "/th/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___vi",
    path: "/vi/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___zh-hans",
    path: "/zh-hans/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "track___zh-hant",
    path: "/zh-hant/track",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/track/index.vue")
  },
  {
    name: "user___en",
    path: "/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___lo",
    path: "/lo/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___ms",
    path: "/ms/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___th",
    path: "/th/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___vi",
    path: "/vi/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___zh-hans",
    path: "/zh-hans/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "user___zh-hant",
    path: "/zh-hant/user",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/user/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___lo",
    path: "/lo",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___zh-hans",
    path: "/zh-hans",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: "index___zh-hant",
    path: "/zh-hant",
    component: () => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/pages/index.vue")
  },
  {
    name: component_45stub8BADXgAiAANNzxjNxtyLzBcrBH8BY9iCmFDmFC82D4gMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub8BADXgAiAANNzxjNxtyLzBcrBH8BY9iCmFDmFC82D4g
  }
]